"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.limitTimeout = void 0;
var logger = require("./../util/logger");
var log = logger.create('Internal Session');
var MAXIMUM_TIMEOUT = 60 * 60 * 1000;
/**
 * Limit timeouts to an hour.
 */
function limitTimeout(description, supplied) {
  if (supplied > MAXIMUM_TIMEOUT) {
    log.warn('CONFIG_EXCESSIVE_TIMEOUT', supplied, description, MAXIMUM_TIMEOUT);
    return MAXIMUM_TIMEOUT;
  }
  return supplied;
}
exports.limitTimeout = limitTimeout;